export default "__VITE_ASSET__33dfd9f9__"